import { DEFAULT_GROUP, gql } from "@edreamsodigeo/frontend-api-client";

export const GET_USER_ACCOUNT = gql`
  query GetUserAccount($userAccountRequest: UserAccountRequest) 
  @update_groups(groups: "${DEFAULT_GROUP},updateShoppingBasketProduct"){
    userAccount(userAccountRequest: $userAccountRequest) {
      isLoggedIn
      userMembership {
        isActive
        accountDetails {
          names
        }
        subscriptionDetails {
          isAutoRenewalEnabled
          isFreeTrial
          currentPlanDetails {
            tier
          }
          availablePerks {
            ... on LimitedAvailableMembershipPerk {
              type
            }
            ... on UnlimitedAvailableMembershipPerk {
              type
            }
          }
        }
      }
    }
  }
`;

export default GET_USER_ACCOUNT;
